import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { alertsParser } from "./alertsParser";
import { baseUrl } from "../../helpers/constants";
import { getCookie, signout } from "../../helpers/cookies";

const customFetchBaseQuery = fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers, { getState }) => {
        const token = getCookie("magiclock_admin_token");
        if (token) {
            headers.set("Authorization", `BEARER ${token}`);
        }
        return headers;
    },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await customFetchBaseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 403) {
        signout(() => {
            window.location.href = "/login";
        });
    }

    return result;
};

const alertsApis = createApi({
    reducerPath: "alertsApis",
    baseQuery: baseQueryWithReauth,
    keepUnusedDataFor: 0,
    tagTypes: ["Alerts"],
    endpoints: (build) => ({
        getAlertsList: build.query({
            query: (params) => ({
                url: "/common/alerts",
                method: "GET",
                params: params,
            }),
            transformResponse: (response) => alertsParser(response),
            providesTags: ["Alerts"],
        }),
        getAlertById: build.query({
            query: (id) => ({
                url: `/common/alerts/${id}`,
                method: "GET",
            }),
            transformResponse: (response) => response.result,
            providesTags: (result, error, id) => [{ type: "Alerts", id }],
        }),
        addNewAlert: build.mutation({
            query: (payload) => ({
                url: "/common/alerts",
                method: "POST",
                body: payload,
            }),
            transformResponse: (response) => response.result,
            invalidatesTags: ["Alerts"],
        }),
        updateAlert: build.mutation({
            query: (payload) => {
                const { id, ...body } = payload;
                return {
                    url: `/common/alerts/${id}`,
                    method: "PUT",
                    body: body,
                };
            },
            transformResponse: (response) => response.result,
            invalidatesTags: ["Alerts"],
        }),
        deleteAlert: build.mutation({
            query: (params) => ({
                url: `/common/alerts/${params.id}`,
                method: "DELETE",
            }),
            transformResponse: (response) => response.result,
            invalidatesTags: ["Alerts"],
        }),
        uploadAlertImage: build.mutation({
            query: (formData) => ({
                url: "/common/upload-single-image",
                method: "POST",
                body: formData,
            }),
            transformResponse: (response) => response.result,
        }),
    }),
});

export const {
    useGetAlertsListQuery,
    useGetAlertByIdQuery,
    useAddNewAlertMutation,
    useUpdateAlertMutation,
    useDeleteAlertMutation,
    useUploadAlertImageMutation,
} = alertsApis;

export default alertsApis;
